export default "__VITE_ASSET__DZKIw9eJ__"